export const iconFontAwesomeTextformattingOutdent = (
	<i className="fa-solid fa-outdent"></i>
);
